import { Play, Pause, SkipForward } from "lucide-react";
import { Card, CardContent } from "../../ui/Card";
import { Button } from "../../ui/Button";
import { PoiPlaybackState } from "./usePoiPlayback";

function formatTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
}

interface PoiPlayerOverlayProps {
  poiState: PoiPlaybackState;
  onTogglePlayPause: () => void;
  onSkipForward: () => void;
}

export function PoiPlayerOverlay({
  poiState,
  onTogglePlayPause,
  onSkipForward,
}: PoiPlayerOverlayProps) {
  return (
    <Card className="w-64 bg-background/90 backdrop-blur-sm border-border/60 shadow-lg">
      <CardContent className="py-3 px-4">
        <p className="text-xs text-muted-foreground mb-1 truncate">Now playing</p>
        <p className="text-sm font-medium truncate mb-2">{poiState.poiName}</p>
        <div className="flex items-center gap-1">
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={onTogglePlayPause}
          >
            {poiState.isPlaying ? (
              <Pause className="h-4 w-4" />
            ) : (
              <Play className="h-4 w-4" />
            )}
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={onSkipForward}
          >
            <SkipForward className="h-4 w-4" />
          </Button>
          <span className="ml-auto text-xs text-muted-foreground tabular-nums">
            {formatTime(poiState.currentTime)} / {formatTime(poiState.duration)}
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
